<template>
  <v-menu  min-width="650" max-width="650" nudge-bottom="40" nudge-left="325" :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{on}">
      <v-btn icon small class="ml-2" v-on="on" @click="opened"><v-icon>mdi-pin</v-icon></v-btn>
    </template>
    <v-card flat :class="darkMode?'':'grey lighten-5'">
      <v-card-title>
        Favourites
        <v-spacer/>
        <v-btn icon small @click="$store.dispatch('help', {title:'Inventory reconciliation',topicId:'RgABAAAA',articleId:'RwAOAAAA'})">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
        <v-menu offset-y :close-on-content-click="false" v-model="menu">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-dots-vertical</v-icon>
          </template>
          <v-card width="250" class="pt-4">
            <v-list-item>
              <v-switch v-model="sortable.options.disabled" label="Enable rearranging" :true-value="false" :false-value="true" hide-details/>
            </v-list-item>
            <v-list-item>
              <v-switch v-model="enableDelete" label="Remove favourites"/>
            </v-list-item>
            <v-list-item>
              <multi-level-select :menuData="favouritesPick" :second.sync="favourite" label="Add favourite" :no-validation="true"
                                  outlined hint="Select a shortcut to add" persistent-hint @change="addFavourite()"/>
            </v-list-item>
          </v-card>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-row ref="favourites">
          <v-col align="center" v-if="!myFavourites.length">
            No favourites defined.
            <v-btn small text color="primary" @click="menu=true">Add a favourite</v-btn>
          </v-col>
          <template v-for="favourite in myFavourites">
            <v-card width="120" height="120" outlined hover :to="to(favourite)" @click="open=false" class="pa-1 ma-1 text-center" :key="favourite.id">
              <v-card-text>
                <v-btn v-if="enableDelete" icon class="red--text" style="position:absolute;right:0px;top:0px" @click.prevent="deleteFavourite(favourite.id)">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
                <v-icon x-large color="primary">{{favourite.icon}}</v-icon>
                <v-icon color="primary" v-if="favourite.plus">mdi-plus-circle</v-icon>
              </v-card-text>
              <v-card-actions style="line-height:1" class="pa-1"><v-spacer/>{{favourite.name}}<v-spacer/></v-card-actions>
            </v-card>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import sortableJS from 'sortablejs';
import reports from '@/mixins/reports'

export default {
  name: 'Favourites',
  mixins: [reports],
  data() {
    return {
      open: false,
      menu: false,
      sortable: {options:{disabled:false}},
      openedFlag: false,
      enableDelete: false,
      myFavourites: [],
      favourite: null,
      favouritesPick: []
    }
  },
  computed: {
    myFavouriteNames() {
      if (!this.$store.getters.userSettings.favourites)
        this.$store.getters.userSettings.favourites = [];
      return this.$store.getters.userSettings.favourites;
    },
    permissions() {
      return this.$store.getters.company.permissions;
    }
  },
  created() {
    if (this.permissions.includes('production')) {
      this.favouritesPick.push({name:'Production',id:'production',
                                      menu:[{name:'Mashing',icon:'mdi-cogs',id:'ProductionMashing'},
                                            {name:'Create mash',icon:'mdi-cogs',plus:true,id:'ProductionMashingEditNew'},
                                            {name:'Distilling',icon:'mdi-cogs',id:'ProductionDistilling'},
                                            {name:'Create distillation',icon:'mdi-cogs',plus:true,id:'ProductionDistillingEditNew'},
                                            {name:'Blending',icon:'mdi-cogs',id:'ProductionBlending'},
                                            {name:'Create blend',icon:'mdi-cogs',plus:true,id:'ProductionBlendingEditNew'},
                                            {name:'Bottling',icon:'mdi-cogs',id:'ProductionBottling'},
                                            {name:'Create bottling',icon:'mdi-cogs',plus:true,id:'ProductionBottlingEditNew'},
                                            {name:'Assembly',icon:'mdi-cogs',id:'ProductionAssembly'},
                                            {name:'Create assembly',icon:'mdi-cogs',plus:true,id:'ProductionAssemblyEditNew'}]});
      this.favouritesPick.push({name:'Equipment',id:'equipment',
                                      menu:[{name:'Tanks',icon:'mdi-tools',id:'EquipmentTanks'},
                                            {name:'Fermenters',icon:'mdi-tools',id:'EquipmentFermenters'},
                                            {name:'Stills',icon:'mdi-tools',id:'EquipmentStills'},
                                            {name:'Other equipment',icon:'mdi-tools',id:'EquipmentOther'}]});
    }
    if (this.permissions.includes('inventory'))
      this.favouritesPick.push({name:'Inventory',id:'inventory',
                                      menu:[{name:'Products',icon:'mdi-tag',id:'InventoryProducts'},
                                            {name:'Batch product move list',icon:'mdi-tag',id:'InventoryProductsBatchMove'},
                                            {name:'Create batch product move',icon:'mdi-tag',plus:true,id:'InventoryProductsBatchMoveEditNew'},
                                            {name:'Reconcile product inv',icon:'mdi-tag',plus:true,id:'InventoryProductsReconcile'},
                                            {name:'Bulk containers',icon:'mdi-tag',id:'InventoryBulkContainers'},
                                            {name:'Casks',icon:'mdi-tag',id:'InventoryCasks'},
                                            {name:'Items & services',icon:'mdi-tag',id:'InventoryItems'},
                                            {name:'Reconcile item inventory',icon:'mdi-tag',plus:true,id:'InventoryItemsReconcile'},
                                            {name:'Bundles',icon:'mdi-tag',id:'InventoryBundles'}]});
    if (this.permissions.includes('selling'))
      this.favouritesPick.push({name:'Sales',id:'sales',
                                      menu:[{name:'Estimates',icon:'mdi-cart',id:'SalesEstimates'},
                                            {name:'Create estimate',icon:'mdi-cart',id:'SalesEstimatesEditNew'},
                                            {name:'Sales orders',icon:'mdi-cart',id:'SalesSalesOrders'},
                                            {name:'Create sales order',icon:'mdi-cart',plus:true,id:'SalesSalesOrdersEditNew'},
                                            {name:'Shipments',icon:'mdi-cart',id:'SalesShipments'},
                                            {name:'Create shipment',icon:'mdi-cart',plus:true,id:'SalesShipmentsEditNew'},
                                            {name:'Invoices',icon:'mdi-cart',id:'SalesInvoices'},
                                            {name:'Create invoice',icon:'mdi-cart',plus:true,id:'SalesInvoicesEditNew'},
                                            {name:'Customers',icon:'mdi-cart',id:'SalesCustomers'},
                                            {name:'Sales representitives',icon:'mdi-cart',id:'SalesReps'},
                                            {name:'Returns',icon:'mdi-cart',id:'SalesReturns'}]});
    if (this.permissions.includes('buying'))
      this.favouritesPick.push({name:'Purchasing',id:'purchasing',
                                      menu:[{name:'Purchase orders',icon:'mdi-credit-card-settings',id:'PurchasingPurchaseOrders'},
                                            {name:'Create purchase order',icon:'mdi-credit-card-settings',plus:true,id:'PurchasingPurchaseOrdersEditNew'},
                                            {name:'Inventory receipets',icon:'mdi-credit-card-settings',id:'PurchasingInventoryReceipts'},
                                            {name:'Create inv receipt',icon:'mdi-credit-card-settings',plus:true,id:'PurchasingInventoryReceiptsEditNew'},
                                            {name:'Suppliers',icon:'mdi-credit-card-settings',id:'PurchasingSuppliers'}]});
    if (this.permissions.includes('inventory'))
      this.favouritesPick.push({name:'Alcohol',id:'alcohol',
                                      menu:[{name:'Spirits',icon:'mdi-flask-empty',id:'Spirits'},
                                            {name:'Wine',icon:'mdi-flask-empty',id:'Wine'},
                                            {name:'Non-excise',icon:'mdi-flask-empty',id:'AlcoholNonExcises'}]});
    if (this.permissions.includes('forecasting') || this.permissions.includes('scheduling')) {
      const menu = [];
      if (this.permissions.includes('forecasting'))
        menu.push({name:'Forecasting',icon:'mdi-calendar-month',id:'PlanningForecasting'});
      if (this.permissions.includes('scheduling'))
        menu.push({name:'Scheduling',icon:'mdi-calendar-month',id:'PlanningScheduling'});
      this.favouritesPick.push({name:'Planning',id:'planning', menu});
    }
    if (this.permissions.includes('reports')) {
      const menu = [];
      for (const category of this.reports) {
        if (menu.length)
          menu.push({divider:true});
        for (const report of category.reports)
          menu.push({name:report.shortName??report.name, id:`ReportsView:${report.to}`, icon:'mdi-file-document-outline'});
      }
      this.favouritesPick.push({name:'Reports',id:'reports',menu});
    }

/*
    if (this.permissions.includes('reports')) {
      let i = 0;
      const menu = [];
      for (const category of this.reports) {
        const categoryMenu = {name:category.category, id:`report${i++}`, menu:[]};
        menu.push(categoryMenu);
        for (const report of category.reports)
          categoryMenu.menu.push({name:report.name, id:`ReportsView:${report.to}`, icon:'mdi-file-document-outline'});
      }
      this.favouritesPick.push({name:'Reports',id:'reports',menu});
    }
    */

  },
  methods: {
    to(favourite) {
      const parts = favourite.id.split(':');
      return {name: parts[0], query:{to:parts[1]}};
    },
    opened() {
      if (this.openedFlag)
        return;

      this.myFavourites = this.myFavouriteNames.map(favourite => this.getFavourite(favourite));

      setTimeout(() => {
        const _self = this;
        this.sortable = sortableJS.create(this.$refs.favourites, {
          forceFallback: false,
          disabled: true,
          onEnd({newIndex, oldIndex}) {
            let selected = _self.myFavourites.splice(oldIndex, 1)[0];
            _self.myFavourites.splice(newIndex, 0, selected);
            selected = _self.myFavouriteNames.splice(oldIndex, 1)[0];
            _self.myFavouriteNames.splice(newIndex, 0, selected);
            _self.saveSettings();
          }
        });
      }, 1000);

      this.openedFlag = true;
    },
    getFavourite(favouriteId) {
      for (const menu of this.favouritesPick) {
        const favourite = menu.menu.find(favourite => favourite.id === favouriteId);
        if (favourite)
          return favourite;
      }
    },
    addFavourite() {
      this.myFavouriteNames.push(this.favourite);
      this.myFavourites.push(this.getFavourite(this.favourite));
      this.saveSettings();
      this.$nextTick(() => this.favourite = null);
    },
    deleteFavourite(to) {
      const index = this.myFavouriteNames.findIndex(name => name === to);
      this.myFavouriteNames.splice(index, 1);
      this.myFavourites.splice(index, 1);
      this.saveSettings();
    },
    saveSettings() {
      this.$store.commit('setUserSettings', this.$store.getters.userSettings);
    }
  }
}
</script>